import React from 'react'
import { connect } from 'react-redux'
import { useState, useEffect } from 'react'
import { setTipoVehiculo, setNroTurno } from '../redux/actions/turnero'
import Header from './header'
import Vehiculoseleccionado from './vehiculoseleccionado'
import '../styles/estilos.css'



const Turnos = (props) => {


    const { temp } = props;
    const [cargando, setCargando] = useState(false);


    return (
        <div style={{ position: "relative" }}>





            <Header></Header>

            <div className="container p-4" style={{ textAlign: "center" }}>





                {temp.tipoVehiculo &&
                    <Vehiculoseleccionado></Vehiculoseleccionado>
                }

            </div>



        </div >
    )
}


const mapStateToProps = state => ({
    temp: state.turnero.temp,
    final: state.turnero.final,
    mostrar: state.turnero.mostrar
})

const mapDispatchToProps = {
    setTipoVehiculo: setTipoVehiculo,
    setNroTurno: setNroTurno
}

export default connect(mapStateToProps, mapDispatchToProps)(Turnos)
